import { submitFhirCommentJson, submitVotes } from "../../functions/submitFhirJsonAPI";

const submitCodeSystemComment = async (apiToken, userId, userName, informationType, resourceId,
    resourceTitle, conceptCode, conceptName, conceptDefinition, concept, title, commentSummary,
    termVote, giveAlerts, setCommentEntryState, votes) => {
    if (!votes) {
        if (informationType === "comment") {
            if (title === null || title === undefined || title === "") {
                alert("Comment doesn't have a title");
                return { "success": false };
            }

            if (commentSummary === null || commentSummary === undefined || commentSummary === "") {
                commentSummary = prompt("Comment doesn't have content. Please enter here: ");
                if (commentSummary === "") {
                    let response = await submitCodeSystemComment(apiToken, userId, userName, "comment", resourceId,
                        resourceTitle, conceptCode, conceptName, conceptDefinition, concept, title, commentSummary,
                        termVote, giveAlerts, setCommentEntryState, null);
                    if (response.success) {
                        return { "success": true };
                    } else {
                        return { "success": false };
                    }
                } else if (commentSummary === null) {
                    alert("No summary entered, not submitting comment.");
                    return { "success": false };
                }
            }

            if (!apiToken) {
                alert(`Comment NOT submitted. Please sign in to use this function.`);
            } else {
                let path = '';
                if (conceptCode) {
                    path = `#${conceptCode}`;
                }
                let profileUrl = "http://hl7.org/fhir/uv/ebm/StructureDefinition/comment";
                let commentJson = {
                    "resourceType": "ArtifactAssessment",
                    "meta": { "profile": [profileUrl] },
                    "artifactReference": { "reference": "CodeSystem/" + resourceId, "type": "CodeSystem", "display": resourceTitle },
                    "title": title,
                    "content": [{
                        "summary": commentSummary,
                        "author": { "display": userName },
                        "path": [path]
                    }]
                };
                if (commentSummary === undefined || commentSummary === "") {
                    delete commentJson.content.summary;
                }

                let response;
                try {
                    response = await submitFhirCommentJson(resourceId, title, apiToken, path, commentJson);
                } catch (e) {
                    console.log("FAILURE with submitFhirCommentJson");
                    console.log(e);
                }
                if (response === undefined || response === false || response.success === false) {
                    alert("Comment NOT submitted. Please try again or save comment in another way: " + commentSummary);
                    return { "success": false };
                } else {
                    if (giveAlerts) {
                        alert(`Comment submitted.`);
                    }
                    if (setCommentEntryState) {
                        setCommentEntryState(prevState => { return { ...prevState, "commentSummary": "" } });
                    }
                    return { "success": true };
                }
            }
            //history.push(`/resources/${resourceType}/${resourceId}#${conceptCode}`);
            return;
        } else {

            let termVoteBoolean;
            if (termVote) {
                termVoteBoolean = termVote.toLowerCase() !== "no"
            }

            let termCopy = JSON.parse(JSON.stringify(concept));
            delete termCopy.comments;
            delete termCopy.votes;
            delete termCopy.myvotes;
            delete termCopy.latestValidVote;
            delete termCopy.systemId;
            delete termCopy.systemTitle;
            delete termCopy.systemName;
            delete termCopy.voteLabel;
            delete termCopy.voteComment;
            delete termCopy.changeMade;
            votes = [{
                'codesystem': resourceId,
                'termcode': conceptCode,
                'termconcept': termCopy,
                'vote': termVoteBoolean,  //How the user voted true/false or yes/no
                'votechoice': termVote,   //For something other than true/false or yes/no, but I'll record the yes/no anyways.
                'votecomment': commentSummary
            }];
        }
    }
    let response;
    try {
        response = await submitVotes(votes, apiToken);
    } catch (e) {
        console.log("FAILURE with submitVotes");
        console.log(e);
    }
    if (response === undefined || response === false || response.success === false) {
        if (votes || informationType === "vote") {
            alert("Vote NOT submitted. Please try again. " + JSON.stringify(votes));
        } else {
            alert("Comment NOT submitted. Please try again or save comment in another way: " + commentSummary);
        }
        return { "success": false };
    } else {
        if (giveAlerts) {
            alert(`${informationType} submitted.`);
        }
        if (setCommentEntryState) {
            setCommentEntryState(prevState => { return { ...prevState, "commentSummary": "" } });
        }
        return { "success": true };
    }
};

export default submitCodeSystemComment;